import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './meeting-simple.types';
import * as constants from './meeting-simple.constants';

export const meetingSimpleReducer = generateResourceReducer<types.IMeetingSimple>({
  STORE: constants.STORE_MEETING_SIMPLE,
  CLEAR: constants.CLEAR_MEETING_SIMPLE,
});
